import React from "react";

export const FarmacotherapeutischKompas = ({ ui }) => {
  if (!ui) return null;

  return (
    <div id="farmacotherapeutisch-kompas" className="fk-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>{ui.title}</h2>
        </div>

        <div className="row fk-row">
          <div className="col-md-6 fk-text-column">
            <div className="integration-text">
              <h3 className="fk-headline">{ui.headline}</h3>
              <p className="fk-copy">{ui.copy}</p>
            </div>
          </div>
          <div className="col-md-6 fk-image-wrap">
            <img
              src="/img/farmacotherapeutisch-kompas.png"
              alt={ui.imageAlt}
              className="fk-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmacotherapeutischKompas;
